/* ACTION CATALOG (FIN-11255) */
export const FETCH_ACTION_CATALOG = 'trm/actionCatalog/FETCH';
export const FETCH_ACTION_CATALOG_SUCCESS = 'trm/actionCatalog/FETCH_SUCCESS';
export const CREATE_ACTION = 'trm/actionCatalog/CREATE';
export const UPDATE_ACTION = 'trm/actionCatalog/UPDATE';
export const DELETE_ACTION = 'trm/actionCatalog/DELETE';
export const REORDER_ACTIONS = 'trm/actionCatalog/REORDER';
export const ACTION_CATALOG_ERROR = 'trm/actionCatalog/ERROR';
export const CLEAR_ACTION_CATALOG_ERROR = 'trm/actionCatalog/CLEAR_ERROR';

export const fetchActionCatalog = (options = {}) => ({
  type: FETCH_ACTION_CATALOG,
  payload: { force: options.force === true }
});
export const fetchActionCatalogSuccess = (rows) => ({
  type: FETCH_ACTION_CATALOG_SUCCESS,
  payload: rows
});
export const createAction = (payload) => ({ type: CREATE_ACTION, payload });
export const updateAction = (originalName, payload) => ({
  type: UPDATE_ACTION,
  payload: { originalName, payload }
});
export const deleteAction = (name) => ({ type: DELETE_ACTION, payload: name });
export const reorderActions = (entries) => ({
  type: REORDER_ACTIONS,
  payload: entries
});
export const actionCatalogError = (payload) => ({
  type: ACTION_CATALOG_ERROR,
  payload
});
export const clearActionCatalogError = () => ({
  type: CLEAR_ACTION_CATALOG_ERROR
});
